import { render, staticRenderFns } from "./CoinHistoryDialog.vue?vue&type=template&id=1cff7052"
import script from "./CoinHistoryDialog.vue?vue&type=script&lang=js"
export * from "./CoinHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports